import * as utils from './utils.js';

// namespace complex query builder

var complexQueryBuilder = {};



// check if an array of search values contains any non-empty value
export function hasValidValue(arrOfArgs){

  var valid = false;
  for (var key in arrOfArgs) {
    if ( arrOfArgs[key] != `` )
    {
      valid = true; 
      break;
    }
  }
    return valid;
}

// when some search value is set for a given query part, the part mustn't but optional: set that!
export function setOptional(arrOfArgs){
  
  var optionalArr = {};
  for (var key in arrOfArgs) {
    optionalArr[key] = ( arrOfArgs[key] != `` ? `` : `OPTIONAL`);
  }
  return optionalArr;
}



// ANW

export function buildAnwQuery(advancedLemma, advancedDefinition){

    var anwSubparts = {};

    // match with ANW lemma
    anwSubparts["Lemma"] = ``;
    if (utils.hasNoEmptyValue(advancedLemma))
    {
        var exactSearch = !utils.containsRegex(advancedLemma);

        if (exactSearch)
          {
            anwSubparts["Lemma"] = `{ ?anwLemId rdfs:label ?anwlem .
            values ?anwlem { "${advancedLemma}"@nl "${advancedLemma}" } . }`;
          }
        else
          {
            if (utils.isFullMatchRegex(advancedLemma))
            {
              var valuesBetweenBrackets = utils.convertRegexIntoSeperateValues(advancedLemma);
              anwSubparts["Lemma"] = `{ ?anwLemId rdfs:label ?anwlem .
                values ?anwlem ${valuesBetweenBrackets} . }`;
            }
            else
            {
              anwSubparts["Lemma"] = `FILTER ( regex(?anwLemma, "${advancedLemma}") ) .`;
            }
            
          }
    }
        

    // match with ANW definition
    anwSubparts["Definition"] = ``;
    if (utils.hasNoEmptyValue(advancedDefinition))
    {
        // definition search is always a partial match (user won't type full defintion!)

        anwSubparts["Definition"] = `{ ?anwDefinitionId lemon:value ?anwdef .
          FILTER( regex(?anwdef, "${advancedDefinition}") ) . }`;
    }            

    
    // query without constraint is like requesting the whole database!
    if ( !hasValidValue(anwSubparts) )
      {
        //console.log("Advanced ANW query won't be sent as it has no conditions");
        return ``;
      }

    // query

    return `
        PREFIX ontolex: <http://www.w3.org/ns/lemon/ontolex#>
        PREFIX anw: <http://rdf.ivdnt.org/lexica/anw>
        PREFIX anwsch: <http://rdf.ivdnt.org/schema/anw/>
        PREFIX lemon: <http://lemon-model.net/lemon#>
      
        SELECT DISTINCT (?anwLemId AS ?anwColorId) ?anwLemma ?anwDefinition  ?anwDefinitionComplement
        WHERE {
            ?anwLemId rdfs:label ?anwLemma .
            ?anwLemId ontolex:sense ?anwSenseId .
            ?anwSenseId lemon:definition ?anwDefinitionId .
            ?anwDefinitionId lemon:value ?anwDefinition .
            OPTIONAL { ?anwDefinitionId anwsch:definitionComplement ?anwDefinitionComplement .}
            FILTER regex(?anwDefinition, ".+") .
            ${anwSubparts["Lemma"]}
            ${anwSubparts["Definition"]}
        }`;
};



// CELEX

export function buildCelexQuery(paradigmLimit, advancedLemma, advancedWordform, advancedNumber, advancedGender){

    var celexSubparts = {};
    var celexOPTIONAL = {};

    // match with Celex lemma
    celexSubparts["Lemma"] = ``;
    if (utils.hasNoEmptyValue(advancedLemma))
    {
      var exactSearch = !utils.containsRegex(advancedLemma);

      if (exactSearch)
        {
          celexSubparts["Lemma"] = `{ ?celexLemmaId ontolex:canonicalForm [ontolex:writtenRep ?celexlem] .
          values ?celexlem { "${advancedLemma}"@nl "${advancedLemma}" } . }`;
        }
      else
        {
          if (utils.isFullMatchRegex(advancedLemma))
          {
            var valuesBetweenBrackets = utils.convertRegexIntoSeperateValues(advancedLemma);
            celexSubparts["Lemma"] = `{ ?celexLemmaId ontolex:canonicalForm [ontolex:writtenRep ?celexlem] .
              values ?celexlem ${valuesBetweenBrackets} . }`;
          }
          else
          {
            celexSubparts["Lemma"] = `FILTER ( regex(?celexLemma, "${advancedLemma}") ) .`;
          }
          
        }
    }            

    // match with Celex wordform
    celexSubparts["Wordform"] = ``;
    if (utils.hasNoEmptyValue(advancedWordform))
    {
      var exactSearch = !utils.containsRegex(advancedWordform);

      if (exactSearch)
        {
          celexSubparts["Wordform"] = `{ ?celexWordformId ontolex:writtenRep ?celexwf .
          values ?celexwf { "${advancedWordform}"@nl "${advancedWordform}" } . }`;
        }
      else
        {
          if (utils.isFullMatchRegex(advancedWordform))
          {
            var valuesBetweenBrackets = utils.convertRegexIntoSeperateValues(advancedWordform);
            celexSubparts["Wordform"] = `{ ?celexWordformId ontolex:writtenRep ?celexwf .
              values ?celexwf ${valuesBetweenBrackets} . }`;
          }
          else
          {
            celexSubparts["Wordform"] = `FILTER ( regex(?celexWordform, "${advancedWordform}") ) .`;
          }
          
        }
    }    
    
    // match with Celex number
    celexSubparts["Number"] = ``;
    if (utils.hasNoEmptyValue(advancedNumber))
    {
      celexSubparts["Number"] = `FILTER ( regex(?celexNumber, "${advancedNumber}") ) .`;
    }   
    
    // match with Celex gender
    celexSubparts["Gender"] = ``;
    if (utils.hasNoEmptyValue(advancedGender))
    {
      celexSubparts["Gender"] =
        `
        { 
          { FILTER ( regex(?g, "${advancedGender}") ) } 
          UNION 
          { FILTER ( regex(?celexGender, "${advancedGender}") ) } 
          UNION 
          { FILTER ( regex(?celexJoinGender, "${advancedGender}") ) } 
        }.
        `;         
    }   



    // query without constraint is like requesting the whole database!
    if ( !hasValidValue(celexSubparts) )
      {
        //console.log("Advanced Celex query won't be sent as it has no conditions");
        return ``;
      }

    // when some search value is set for a given query part, the part mustn't but optional
    celexOPTIONAL = setOptional(celexSubparts);

    // query

    return `
            PREFIX ontolex: <http://www.w3.org/ns/lemon/ontolex#>
            PREFIX celex: <http://rdf.ivdnt.org/lexica/celex/>
            PREFIX UD: <http://rdf.ivdnt.org/vocabs/UniversalDependencies2#>
            PREFIX decomp: <http://www.w3.org/ns/lemon/decomp#>
            PREFIX gold: <http://purl.org/linguistics/gold#>
            PREFIX UDvocab: <http://rdf.ivdnt.org/vocabs/UniversalDependencies2#>
          
            SELECT DISTINCT (?celexLemmaId AS ?celexColorId) ?celexLemma ?celexWordform ?celexPronunciation ?celexNumber ?celexGender ?celexJoinGender ?celexMorph            
            WHERE {
              {
              SELECT DISTINCT ?celexLemmaId ?celexLemma ?celexWordform ?celexPronunciation ?celexNumber ?celexGender ?celexJoinGender
              FROM <http://rdf.ivdnt.org/lexica/celex/>
              WHERE {

              ?celexLemmaId ontolex:canonicalForm [ontolex:writtenRep ?celexLemma] .              
              ?celexLemmaId ontolex:lexicalForm ?celexWordformId .
              ?celexWordformId ontolex:writtenRep ?celexWordform .

              ${celexSubparts["Lemma"]}
              ${celexSubparts["Wordform"]}

              ${celexOPTIONAL["Number"]} {
                  ?celexWordformId UDvocab:Number ?dcn . 
                  ${celexSubparts["Number"]}
                  #FILTER(REGEX(?dcn, "_Number$", "i")) .
                  bind( REPLACE(STR(?dcn), "_Number$", "") AS ?celexNumber ) .
              }   
              OPTIONAL { 
                   ?celexLemmaId ontolex:lexicalForm ?celexWordformId . 
                   ?celexWordformId  ontolex:phoneticRep ?celexPronunciation . 
              }
              ${celexOPTIONAL["Gender"]} {
                  ?celexLemmaId UDvocab:Gender ?g . 
                  #FILTER(REGEX(?g, "_Gender$", "i")) .
                  bind( REPLACE(STR(?g), "_Gender$", "") AS ?celexGender ) .

                    ?celexLemmaId UDvocab:Gender ?g . 
                    bind( STR(
                      if(?g = UDvocab:Fem_Gender,
                        UDvocab:Fem,
                        if(?g = UDvocab:Masc_Gender, 
                          UDvocab:Masc, 
                          if(?g = UDvocab:Com_Gender, 
                            UDvocab:Com, 
                            if(?g = UDvocab:Neut_Gender, 
                              UDvocab:Neut, 
                              ?g 
                            ) 
                          )
                        )
                      ))
                      AS ?celexJoinGender 
                    )
                    ${celexSubparts["Gender"]}
                }
              }
              LIMIT ${paradigmLimit}            
            }
              

            OPTIONAL {
              SELECT ?celexLemmaId (group_concat(DISTINCT concat(?partNr,":",COALESCE(?subLemma,"[infix]"));separator=" + ") as ?celexMorph) 
              FROM <http://rdf.ivdnt.org/lexica/celex/>
              WHERE {
                  SELECT ?celexLemmaId ?celexComp ?aWordformId ?subLemma ?partNr 
                  WHERE {
                          {
                          ?celexLemmaId ontolex:lexicalForm ?aWordformId .    
                          ?celexLemmaId decomp:constituent ?celexComp .          
                          OPTIONAL { ?celexComp gold:stem [ontolex:writtenRep ?subLemma] . }
                          OPTIONAL { ?celexComp decomp:correspondsTo [ ontolex:canonicalForm [ontolex:writtenRep ?subLemma]] . }                              
                          } 
                          { 
                              { 
                                  {?celexLemmaId <http://www.w3.org/1999/02/22-rdf-syntax-ns#_1> ?celexComp .} 
                                  UNION 
                                  {?celexLemmaId <http://www.w3.org/1999/02/22-rdf-syntax-ns#_2> ?celexComp .} 
                                  UNION 
                                  {?celexLemmaId <http://www.w3.org/1999/02/22-rdf-syntax-ns#_3> ?celexComp .} 
                                  UNION 
                                  {?celexLemmaId <http://www.w3.org/1999/02/22-rdf-syntax-ns#_4> ?celexComp .} 
                                  UNION 
                                  {?celexLemmaId <http://www.w3.org/1999/02/22-rdf-syntax-ns#_5> ?celexComp .} 
                                  UNION 
                                  {?celexLemmaId <http://www.w3.org/1999/02/22-rdf-syntax-ns#_6> ?celexComp .} 
                              } 
                          ?celexLemmaId ?rdfsynt ?celexComp .
                          BIND(IF(STRSTARTS(str(?rdfsynt), "http://www.w3.org/1999/02/22-rdf-syntax-ns#"), replace(STRAFTER(str(?rdfsynt), "#"), "_", ""), "999") AS ?partNr) . 
                          MINUS {
                              ?celexLemmaId <http://www.w3.org/1999/02/22-rdf-syntax-ns#0> ?celexComp .
                              }
                          } 
                      FILTER (?partNr != "999") .
                      } 
                  ORDER BY ?partNr                  
                  }          
              GROUP BY ?aWordformId ?celexLemmaId 
              }
          }
          `;
};


// DUEL-ME

export function  buildDuelMeQuery(advancedLemma, advancedExample, advancedAttestation, advancedNumber, advancedGender){

    var duelMeSubparts = {};
    var duelMeOPTIONAL = {}

    // match with DuelMe lemma
    duelMeSubparts["Lemma"] = ``;
    if (utils.hasNoEmptyValue(advancedLemma))
    {
      var exactSearch = !utils.containsRegex(advancedLemma);

      if (exactSearch)
        {
          duelMeSubparts["Lemma"] = `{ ?y lmf:hasLemma ?dl .
          values ?dl { "${advancedLemma}"@nl "${advancedLemma}" } . }`;
        }
      else
        {
          if (utils.isFullMatchRegex(advancedLemma))
          {
            var valuesBetweenBrackets = utils.convertRegexIntoSeperateValues(advancedLemma);
            duelMeSubparts["Lemma"] =`{ ?y lmf:hasLemma ?dl .
              values ?dl ${valuesBetweenBrackets} . }`;
          }
          else
          {
            duelMeSubparts["Lemma"] =`FILTER ( regex(?duelMeLemma, "${advancedLemma}") ) .`;
          }
          
        }

    }            

    // match with DuelMe example
    duelMeSubparts["Example"] = ``;
    if (utils.hasNoEmptyValue(advancedExample))
    {
      duelMeSubparts["Example"] = `FILTER ( regex(?duelMeExample, "${advancedExample}") ) .`;
    }       
    
    // match with DuelMe attestation
    duelMeSubparts["Attestation"] = ``;
    if (utils.hasNoEmptyValue(advancedAttestation))
    {
      duelMeSubparts["Attestation"] = `FILTER ( regex(?duelMeAttestation, "${advancedAttestation}") ) .`;
    } 
    
    // match with DuelMe number
    duelMeSubparts["Number"] = ``;
    if (utils.hasNoEmptyValue(advancedNumber))
    {
      duelMeSubparts["Number"] = `FILTER ( regex(?duelMeNumber, "${advancedNumber}") ) .`;
    }   
    
    // match with DuelMe gender
    duelMeSubparts["Gender"] = ``;
    if (utils.hasNoEmptyValue(advancedGender))
    {
      duelMeSubparts["Gender"] = `{ { FILTER ( regex(?duelMeGender, "${advancedGender}") ) } UNION { FILTER ( regex(?duelMeJoinGender, "${advancedGender}") ) } } . `;
    }   


    // query without constraint is like requesting the whole database!
    if ( !hasValidValue(duelMeSubparts) )
      {
        //console.log("Advanced DuelMe query won't be sent as it has no conditions");
        return ``;
      }

    // when some search value is set for a given query part, the part mustn't but optional
    duelMeOPTIONAL = setOptional(duelMeSubparts);

    // query

    return `
        PREFIX duelme: <http://rdf.ivdnt.org/lexica/duelme>
        PREFIX intskos: <http://ivdnt.org/schema/lexica#>
        PREFIX lmf: <http://www.lexinfo.net/lmf>
        PREFIX ontolex: <http://www.w3.org/ns/lemon/ontolex#>
        PREFIX UDvocab: <http://rdf.ivdnt.org/vocabs/UniversalDependencies2#>
        PREFIX prov: <http://www.w3.org/ns/prov#>
        
        SELECT DISTINCT (?d AS ?duelMeColorId) ?duelMeExample ?duelMeAttestation ?duelMeLemma ?duelMeGender ?duelMeJoinGender ?duelMeNumber
        WHERE {
          ?d intskos:ExampleSentence ?duelMeExample .
          ${duelMeSubparts["Example"]}

          ?d lmf:ListOfComponents [lmf:Component ?y] .
          ?y lmf:hasLemma ?duelMeLemma .
          ${duelMeSubparts["Lemma"]}

          ${duelMeOPTIONAL["Attestation"]} { 
                ?d intskos:hasAttestation ?m . 
                ?m prov:value ?duelMeAttestation
                ${duelMeSubparts["Attestation"]}
                }
          
          ${duelMeOPTIONAL["Gender"]} {
              ?y UDvocab:Gender ?g .   
              #FILTER(REGEX(?g, "_Gender$", "i")) .
              bind( REPLACE(STR(?g), "_Gender$", "") AS ?duelMeGender ) .

              ?y UDvocab:Gender ?g .   
              bind( STR(
                  if(?g = UDvocab:Fem_Gender,
                    UDvocab:Fem,
                  if(?g = UDvocab:Masc_Gender, 
                    UDvocab:Masc, 
                      if(?g = UDvocab:Com_Gender, 
                        UDvocab:Com, 
                        if(?g = UDvocab:Neut_Gender, 
                          UDvocab:Neut, 
                          ?g 
                        ) 
                      )
                    )
                  ))
                  AS ?duelMeJoinGender 
              )
              ${duelMeSubparts["Gender"]}
          }

          ${duelMeOPTIONAL["Number"]} {
            ?y UDvocab:Number ?dcn .   
            #FILTER(REGEX(?dcn, "_Number$", "i")) .
            bind( REPLACE(STR(?dcn), "_Number$", "") AS ?duelMeNumber ) .   
            ${duelMeSubparts["Number"]}       
          }        
          
        }
        `;
};




// DUEL-ME  Multiword Expressions

export function  buildDuelMeMweQuery(advancedLemma, advancedLemPos){

  var duelMeSubparts = {};

  // match with DuelMe lemma
  duelMeSubparts["Lemma"] = ``;
  if (utils.hasNoEmptyValue(advancedLemma))
  {
    var exactSearch = !utils.containsRegex(advancedLemma);

    duelMeSubparts["Lemma"] = `FILTER ( regex(?multiwordexp, "${advancedLemma}") ) .`;
  }      
  


  // match with DuelMe example 
  duelMeSubparts["LemPos"] = ``;
  if (utils.hasNoEmptyValue(advancedLemPos))
  {
    var exactSearch = !utils.containsRegex(advancedLemPos);

    if (exactSearch)
      {
        duelMeSubparts["LemPos"] = `values ?syncat { "${advancedLemPos}" } . `;
      }
    else
      {
        if (utils.isFullMatchRegex(advancedLemPos))
        {
          var valuesBetweenBrackets = utils.convertRegexIntoSeperateValues(advancedLemPos);
          duelMeSubparts["LemPos"] = `values ?syncat { "${valuesBetweenBrackets}" } . `;          
        }
        else
        {
          duelMeSubparts["LemPos"] = `FILTER regex(?syncat, "${advancedLemPos}") .`;
        }
        
      }

    
  }       



  // query without constraint is like requesting the whole database!
  if ( !hasValidValue(duelMeSubparts) )
    {
      //console.log("Advanced DuelMe query won't be sent as it has no conditions");
      return ``;
    }

  // when some search value is set for a given query part, the part mustn't but optional
  //duelMeOPTIONAL = setOptional(duelMeSubparts);

  // query

  return `
    PREFIX duelme: <http://rdf.ivdnt.org/lexica/duelme>
    PREFIX intskos: <http://ivdnt.org/schema/lexica#>
    PREFIX lmf: <http://www.lexinfo.net/lmf>
    PREFIX ontolex: <http://www.w3.org/ns/lemon/ontolex#>
    PREFIX UD: <http://rdf.ivdnt.org/vocabs/UniversalDependencies2#>
    PREFIX prov: <http://www.w3.org/ns/prov#>
    PREFIX dcterms: <http://purl.org/dc/terms/>
    PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>    
    PREFIX olia: <http://purl.org/olia/olia.owl#>
    
    SELECT ?duelMeMweLemma  ?duelMeMwePos ?duelMeMweParts
    FROM <http://rdf.ivdnt.org/lexica/duelme>
    WHERE {      
      SELECT replace(STRAFTER(str(?multiwordexp), "duelme_"), "_", " ") AS ?duelMeMweLemma ?mwepattern (?syncat AS ?duelMeMwePos) group_concat(DISTINCT ?subsubcat; separator=" + ") AS ?duelMeMweParts
      WHERE  { 
            {
            SELECT DISTINCT ?multiwordexp ?mwepattern (STRAFTER(str(?trueSynCat), '#') AS ?syncat) (STRAFTER(str(?trueSubsubcat), '#') AS ?subsubcat) 
            FROM <http://rdf.ivdnt.org/lexica/duelme>
            WHERE {
                {
                ?multiwordexp lmf:hasMWEPattern ?mwepattern .      
                ?mwepattern lmf:hasMWENode ?node .
                ?node rdf:type ?syncat .
                filter regex(str(?syncat), 'http://purl.org/olia/olia.owl') .
            	  bind(
                    if(?syncat = olia:NounPhrase,
                      olia:NP,
                      if(?syncat = olia:VerbPhrase, 
                        olia:VP, 
                        if(?syncat = olia:Determiner, 
                          olia:DP, 
                          if(?syncat = olia:Verb, 
                            olia:V, 
                            if(?syncat = olia:PrepositionalPhrase, 
                            olia:PP, 
                              if(?syncat = olia:Preposition, 
                              olia:P, 
                                if(?syncat = olia:AdjectivePhrase, 
                                olia:AP, 
                                  if(?syncat = olia:SubordicateClause, 
                                  olia:SC, 
                                  olia:Unknown
                                  
                                  )
                                
                                )
                              
                              )
                            
                            )
              				
                          )
                        )
                      )
                    )
                    AS ?trueSynCat )
                  ?node lmf:hasMWEEdge ?subnode .
                  ?subnode lmf:hasMWENode ?subsubnode .
            	    ?subsubnode rdf:type ?subsubcat .  
                  filter regex(str(?subsubcat), 'http://purl.org/olia/olia.owl') .
                  bind(
                    if(?subsubcat = olia:NounPhrase,
                      olia:NP,
                      if(?subsubcat = olia:VerbPhrase, 
                        olia:VP, 
                        if(?subsubcat = olia:Determiner, 
                          olia:DP, 
                          if(?subsubcat = olia:Verb, 
                            olia:V, 
                            if(?subsubcat = olia:PrepositionalPhrase, 
                            olia:PP, 
                              if(?subsubcat = olia:Preposition, 
                              olia:P, 
                                if(?subsubcat = olia:AdjectivePhrase, 
                                olia:AP, 
                                  if(?subsubcat = olia:SubordicateClause, 
                                  olia:SC, 
                                  olia:Unknown
                                  
                                  )
                                
                                )
                              
                              )
                            
                            )
              				
                          )
                        )
                      )
                    )
                    AS ?trueSubsubcat )
                  
                    ${duelMeSubparts["Lemma"]}
                    }                   
                    
            }
            ORDER BY ?partnr
            
          } 
          {
            ${duelMeSubparts["LemPos"]}
          }
        } 
      GROUP BY ?multiwordexp ?mwepattern  ?syncat 
    
    }`;
}; 




// MOLEX

export function buildMolexQuery(paradigmLimit, advancedLemma, advancedWordform, advancedLemPos, advancedWordformPos, advancedNumber, advancedGender){

  
    var molexSubparts = {};
    var molexOPTIONAL = {};

    // match with Molex lemma
    molexSubparts["Lemma"] = ``;
    if (utils.hasNoEmptyValue(advancedLemma))
    {
      var exactSearch = !utils.containsRegex(advancedLemma);

      if (exactSearch)
        {
          molexSubparts["Lemma"] = `{ ?molexLemCFId ontolex:writtenRep ?molexlem . 
                values ?molexlem { "${advancedLemma}"@nl "${advancedLemma}" } . }`;
        }
      else
        {
          if (utils.isFullMatchRegex(advancedLemma))
          {
            var valuesBetweenBrackets = utils.convertRegexIntoSeperateValues(advancedLemma);
            molexSubparts["Lemma"] = `{ ?molexLemCFId ontolex:writtenRep ?molexlem . 
              values ?molexlem ${valuesBetweenBrackets} . }`;
          }
          else
          {
            molexSubparts["Lemma"] = `FILTER regex(?molexLemma, "${advancedLemma}") .`;
          }
        }
        
    }
      
    
    // match with Molex wordform
    molexSubparts["Wordform"] = ``;
    if (utils.hasNoEmptyValue(advancedWordform))
    {
      var exactSearch = !utils.containsRegex(advancedWordform);

      if (exactSearch)
        {
          molexSubparts["Wordform"] = `{ ?molexWordformId ontolex:writtenRep ?molexwf .
          values ?molexwf { "${advancedWordform}"@nl "${advancedWordform}" } . }`;
        }
      else
        {
          if (utils.isFullMatchRegex(advancedWordform))
          {
            var valuesBetweenBrackets = utils.convertRegexIntoSeperateValues(advancedWordform);
            molexSubparts["Wordform"] = `{ ?molexWordformId ontolex:writtenRep ?molexwf .
              values ?molexwf ${valuesBetweenBrackets} . }`;
          }
          else
          {
            molexSubparts["Wordform"] = `FILTER regex(?molexWordform, "${advancedWordform}") .`;
          }
          
        }
    }
      
    molexSubparts["LemPos"] = ``;
    if (utils.hasNoEmptyValue(advancedLemPos))
    {
      // pos search is always exact
      molexSubparts["LemPos"] = `FILTER regex(?molexLemPos, "${advancedLemPos}") .`;

      //molexSubparts.push(`{ ?molexLemId UD:pos ?molexlempos .
      // values ?molexlempos {"http://universaldependencies.org/u/pos/${this.molexLemPos}"@nl "http://universaldependencies.org/u/pos/${this.molexLemPos}"} . }`);
    }
      
    molexSubparts["WordformPos"] = ``;
    if (utils.hasNoEmptyValue(advancedWordformPos))
      {
      // pos search is always exact
      molexSubparts["WordformPos"] = `FILTER regex(?molexWordformPos, "${advancedWordformPos}") .`;

      //molexSubparts.push(`{ ?molexWordformId UD:pos ?molexwfpos .
      //values ?molexwfpos {"http://universaldependencies.org/u/pos/${this.molexWordformPos}"@nl "http://universaldependencies.org/u/pos/${this.molexWordformPos}"} . }`);
      }


      // match with Molex number
      molexSubparts["Number"] = ``;
      if (utils.hasNoEmptyValue(advancedNumber))
      {
        molexSubparts["Number"] = `FILTER ( regex(?molexNumber, "${advancedNumber}") ) .`;
      }   
      
      // match with Molex gender
      molexSubparts["Gender"] = ``;
      if (utils.hasNoEmptyValue(advancedGender))
      {
        molexSubparts["Gender"] =
          `
          { 
            #{ FILTER ( regex(?mxGender, "${advancedGender}") ) } 
            #UNION 
            { FILTER ( regex(?molexGender, "${advancedGender}") ) } 
            UNION 
            { FILTER ( regex(?molexJoinGender, "${advancedGender}") ) } 
          } .`;
      }


    // query without constraint is like requesting the whole database!
    if ( !hasValidValue(molexSubparts) )
      {
        //console.log("Advanced MoLex query won't be sent as it has no conditions");
        return ``;
      }      
    
    // when some search value is set for a given query part, the part mustn't but optional
    molexOPTIONAL = setOptional(molexSubparts);

  
    // query    
    
    return `
        PREFIX ontolex: <http://www.w3.org/ns/lemon/ontolex#>
        PREFIX UD: <http://universaldependencies.org/u/>
        PREFIX UDgender: <http://universaldependencies.org/u/feat/Gender.html#>
        PREFIX UDnumber: <http://universaldependencies.org/u/feat/Number.html#>
        PREFIX UDvocab: <http://rdf.ivdnt.org/vocabs/UniversalDependencies2#>
        PREFIX diamant: <http://rdf.ivdnt.org/schema/diamant#>
        
        SELECT DISTINCT (?molexLemId AS ?molexColorId) ?molexLemma ?molexLemPos ?molexWordform ?molexHyphenation ?molexWordformPos ?molexGender ?molexJoinGender ?molexNumber
        WHERE {
          ?molexLemId ontolex:canonicalForm ?molexLemCFId .
          ?molexLemCFId ontolex:writtenRep ?molexLemma .
          ${molexSubparts["Lemma"]}

          ${molexOPTIONAL["Gender"]} {
            
            ?molexLemId UD:Gender ?mxGender .
            bind( STR(
              if(?mxGender = UDgender:Fem,   # BEWARE: UDgender -> UDvocab
              UDvocab:Fem,
                if(?mxGender = UDgender:Masc, 
                  UDvocab:Masc, 
                  if(?mxGender = UDgender:Neut, 
                    UDvocab:Neut, 
                    ?mxGender
                  )
                )
              ))
              AS ?molexGender
            ) 

            bind( STR(
              if(?mxGender = UDgender:Fem,     # BEWARE: UDgender -> UDvocab
              UDvocab:Com,
                if(?mxGender = UDgender:Masc, 
                  UDvocab:Com, 
                  if(?mxGender = UDgender:Neut, 
                    UDvocab:Neut, 
                    UDvocab:Com
                  )
                )
              ))
              AS ?molexJoinGender
            )
            ${molexSubparts["Gender"]}
          }

          OPTIONAL {
            ?molexLemId UD:VerbForm ?verbform .
          }
          ?molexLemId UD:pos ?molexLemPos .
          ${molexSubparts["LemPos"]}

          ?molexLemId ontolex:lexicalForm ?molexWordformId .
          ?molexWordformId UD:pos ?molexWordformPos .
          ${molexSubparts["WordformPos"]}

          ${molexOPTIONAL["Number"]} {
            ?molexWordformId UD:Number ?mxNumber .
            ${molexSubparts["Number"]}
            bind( STR(
              if(?mxNumber = UDnumber:Plur,
                UDvocab:Plur, 
                if(?mxNumber = UDnumber:Sing,
                  UDvocab:Sing, 
                  ?mxNumber
                  )
              ))
              AS ?molexNumber  
            ) 
          }
          ${molexOPTIONAL["Wordform"]} {
            ?molexWordformId ontolex:writtenRep ?molexWordform .
            ${molexSubparts["Wordform"]}
          }
          OPTIONAL {
            ?molexWordformId diamant:hyphenation ?molexHyphenation .
          }
          
        }
        LIMIT ${paradigmLimit}`;
};



// DIAMANT

export function buildDiamantQuery(advancedLemma, advancedDefinition, advancedSynDefinition ){


    var diamantSubparts = {};
    var diamantOPTIONAL = {}

    // match diamant lemma
    diamantSubparts["Lemma"] = ``;
    if (utils.hasNoEmptyValue(advancedLemma))
        {
        var exactSearch = !utils.containsRegex(advancedLemma);

        if (exactSearch)
            diamantSubparts["Lemma"] = `{ ?canonicalFormID ontolex:writtenRep ?l . 
                values ?l{ "${advancedLemma}"@nl "${advancedLemma}" } . }`;
        else
          diamantSubparts["Lemma"] = `FILTER regex(?diamantLemma, "${advancedLemma}") .`;
        }

    // match def
    diamantSubparts["Definition"] = ``;
    if (utils.hasNoEmptyValue(advancedDefinition))
    {
        // syndef is always partial match (user won't type full definition!)
    
        diamantSubparts["Definition"] = `FILTER( regex(?diamantDefinition, "${advancedDefinition}") ) .`;
    }

    // match syndef
    diamantSubparts["SynDefinition"] = ``;
    if (utils.hasNoEmptyValue(advancedSynDefinition))
        {
        // syn is always partial match (user won't type full definition!)
        
        diamantSubparts["SynDefinition"] = `FILTER( regex(?diamantSynDefinition, "${advancedSynDefinition}") ) .`;
        }


    // query without constraint is like requesting the whole database!
    if ( !hasValidValue(diamantSubparts) )
      {
        //console.log("Advanced Diamant query won't be sent as it has no conditions");
        return ``;
      }
    

    // when some search value is set for a given query part, the part mustn't but optional
    //diamantOPTIONAL = setOptional(diamantSubparts);

    // query
    
    return `
        PREFIX xsd: <http://www.w3.org/2001/XMLSchema#>
        PREFIX prov: <http://www.w3.org/ns/prov#>
        PREFIX diamant: <http://rdf.ivdnt.org/schema/diamant#>
        PREFIX lexinfo: <http://www.lexinfo.net/ontology/2.0/lexinfo#>
        PREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>
        PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>
        PREFIX lemon: <http://lemon-model.net/lemon#>
        PREFIX ontolex: <http://www.w3.org/ns/lemon/ontolex#>
        PREFIX ud: <http://universaldependencies.org/u/pos/>
        PREFIX UD: <http://rdf.ivdnt.org/vocabs/UniversalDependencies2#>
        PREFIX skos: <http://www.w3.org/2004/02/skos/core#>
        PREFIX dcterms: <http://purl.org/dc/terms/>
        PREFIX dc: <http://purl.org/dc/terms/>
        
        SELECT DISTINCT (?diamantEntryId AS ?diamantColorId) ?diamantLemma ?diamantDefinition group_concat(distinct ?diamantSynDefinition; separator="<br>") AS ?diamantSynDefinition ?witnessYearFrom ?witnessYearTo
        WHERE
        {
            ?diamantEntryId ontolex:canonicalForm ?canonicalFormID .
            ?canonicalFormID ontolex:writtenRep ?diamantLemma .
            ${diamantSubparts["Lemma"]} 
            ?diamantEntryId ontolex:sense ?diamantSenseId .
            ?diamantSenseId lemon:definition ?synDefId .
            ?diamantSenseId lemon:definition ?senseDefId .
            ?diamantSenseId diamant:attestation ?attestationId .  
            ?attestationId diamant:text ?quotationId .
            ?senseDefId diamant:definitionText ?diamantDefinition .
            ${diamantSubparts["Definition"]}
            ?synDefId diamant:definitionText ?diamantSynDefinition .
            ${diamantSubparts["SynDefinition"]}
            OPTIONAL { ?quotationId diamant:witnessYearFrom ?witnessYearFrom . }
            OPTIONAL { ?quotationId diamant:witnessYearTo ?witnessYearTo . }            
        }
        LIMIT 10000`;
};







//  CELEX + MOLEX together ----------------------------------------------------------------------------------------------------------------

export function buildCelexMolexQuery(paradigmLimit, advancedLemma, advancedWordform, advancedLemPos, advancedWordformPos, advancedNumber, advancedGender, advancedActiveSets){

  var celexMode = advancedActiveSets.indexOf("celex")<0 ? `#`:``;
  var molexMode = advancedActiveSets.indexOf("molex")<0 ? `#`:``;

  var celexSubparts = {};
  var celexOPTIONAL = {};

  // match with Celex lemma
  celexSubparts["Lemma"] = ``;
  if (utils.hasNoEmptyValue(advancedLemma))
  {
    var exactSearch = !utils.containsRegex(advancedLemma);

    if (exactSearch)
      {
        celexSubparts["Lemma"] = 
        `${celexMode} values ?celexLemma { "${advancedLemma}"@nl "${advancedLemma}" } . `;
      }
    else
      {
        if (utils.isFullMatchRegex(advancedLemma))
        {
          var valuesBetweenBrackets = utils.convertRegexIntoSeperateValues(advancedLemma);
          celexSubparts["Lemma"] = 
          `${celexMode} values ?celexLemma ${valuesBetweenBrackets} . `;
        }
        else
        {
          celexSubparts["Lemma"] = `${celexMode} FILTER ( regex(?celexLemma, "${advancedLemma}") ) .`;
        }
        
      }
  }            

  // match with Celex wordform
  celexSubparts["Wordform"] = ``;
  if (utils.hasNoEmptyValue(advancedWordform))
  {
    var exactSearch = !utils.containsRegex(advancedWordform);

    if (exactSearch)
      {
        celexSubparts["Wordform"] = 
        `${celexMode} values ?celexWordform { "${advancedWordform}"@nl "${advancedWordform}" } . `;
      }
    else
      {
        if (utils.isFullMatchRegex(advancedWordform))
        {
          var valuesBetweenBrackets = utils.convertRegexIntoSeperateValues(advancedWordform);
          celexSubparts["Wordform"] = 
          `${celexMode} values ?celexWordform ${valuesBetweenBrackets} . `;
        }
        else
        {
          celexSubparts["Wordform"] = `${celexMode} FILTER ( regex(?celexWordform, "${advancedWordform}") ) .`;
        }
        
      }
  }    
  
  // match with Celex number
  celexSubparts["Number"] = ``;
  if (utils.hasNoEmptyValue(advancedNumber))
  {
    celexSubparts["Number"] = `${celexMode} FILTER ( regex(?celexNumber, "${advancedNumber}") ) .`;
  }   
  
  // match with Celex gender
  celexSubparts["Gender"] = ``;
  if (utils.hasNoEmptyValue(advancedGender))
  {
    celexSubparts["Gender"] =
      `
      ${celexMode} { 
      ${celexMode}   { FILTER ( regex(?g, "${advancedGender}") ) } 
      ${celexMode}   UNION 
      ${celexMode}   { FILTER ( regex(?celexGender, "${advancedGender}") ) } 
      ${celexMode}   UNION 
      ${celexMode}   { FILTER ( regex(?commongender_celex, "${advancedGender}") ) } 
      ${celexMode} }.
      `;         
  }   


  var molexSubparts = {};
  var molexOPTIONAL = {};

  // match with Molex lemma
  molexSubparts["Lemma"] = ``;
  if (utils.hasNoEmptyValue(advancedLemma))
  {
    var exactSearch = !utils.containsRegex(advancedLemma);

    if (exactSearch)
      {
        molexSubparts["Lemma"] = 
        `${molexMode} values ?molexLemma { "${advancedLemma}"@nl "${advancedLemma}" } . `;
      }
    else
      {
        if (utils.isFullMatchRegex(advancedLemma))
        {
          var valuesBetweenBrackets = utils.convertRegexIntoSeperateValues(advancedLemma);
          molexSubparts["Lemma"] = 
          `${molexMode} values ?molexLemma ${valuesBetweenBrackets} . `;
        }
        else
        {
          molexSubparts["Lemma"] = `${molexMode} FILTER regex(?molexLemma, "${advancedLemma}") .`;
        }
      }
      
  }
    
  
  // match with Molex wordform
  molexSubparts["Wordform"] = ``;
  if (utils.hasNoEmptyValue(advancedWordform))
  {
    var exactSearch = !utils.containsRegex(advancedWordform);

    if (exactSearch)
      {
        molexSubparts["Wordform"] = 
        `${molexMode} values ?molexWordform { "${advancedWordform}"@nl "${advancedWordform}" } . `;
      }
    else
      {
        if (utils.isFullMatchRegex(advancedWordform))
        {
          var valuesBetweenBrackets = utils.convertRegexIntoSeperateValues(advancedWordform);
          molexSubparts["Wordform"] = 
            `${molexMode} values ?molexWordform ${valuesBetweenBrackets} . `;
        }
        else
        {
          molexSubparts["Wordform"] = `${molexMode} FILTER regex(?molexWordform, "${advancedWordform}") .`;
        }
        
      }
  }
    
  molexSubparts["LemPos"] = ``;
  if (utils.hasNoEmptyValue(advancedLemPos))
    {
      // pos search is always exact
      molexSubparts["LemPos"] = `${molexMode} FILTER regex(?molexLemPos, "${advancedLemPos}") .`;

      //molexSubparts.push(`{ ?molexLemId UD:pos ?molexlempos .
      // values ?molexlempos {"http://universaldependencies.org/u/pos/${this.molexLemPos}"@nl "http://universaldependencies.org/u/pos/${this.molexLemPos}"} . }`);
    }
    
  molexSubparts["WordformPos"] = ``;
  if (utils.hasNoEmptyValue(advancedWordformPos))
    {
    // pos search is always exact
    molexSubparts["WordformPos"] = `${molexMode} FILTER regex(?molexWordformPos, "${advancedWordformPos}") .`;

    //molexSubparts.push(`{ ?molexWordformId UD:pos ?molexwfpos .
    //values ?molexwfpos {"http://universaldependencies.org/u/pos/${this.molexWordformPos}"@nl "http://universaldependencies.org/u/pos/${this.molexWordformPos}"} . }`);
    }


  // match with Molex number
  molexSubparts["Number"] = ``;
  if (utils.hasNoEmptyValue(advancedNumber))
    {
      molexSubparts["Number"] = `${molexMode} FILTER ( regex(?molexNumber, "${advancedNumber}") ) .`;
    }   
    
  // match with Molex gender
  molexSubparts["Gender"] = ``;
  if (utils.hasNoEmptyValue(advancedGender))
    {
      molexSubparts["Gender"] =
        `
        ${molexMode} { 
        ${molexMode}   { FILTER ( regex(?molexGender, "${advancedGender}") ) } 
        ${molexMode}   UNION 
        ${molexMode}   { FILTER ( regex(?commongender_molex, "${advancedGender}") ) } 
        ${molexMode} } .`;
    }



  // query without constraint is like requesting the whole database!
  if ( !hasValidValue(celexSubparts) && !hasValidValue(molexSubparts) )
    {
      //console.log("Advanced CelexMolex query won't be sent as it has no conditions");
      return ``;
    }

  // when some search value is set for a given query part, the part mustn't but optional
  celexOPTIONAL = setOptional(celexSubparts);
  
  // when some search value is set for a given query part, the part mustn't but optional
  molexOPTIONAL = setOptional(molexSubparts);

  // query

  return `
          PREFIX ontolex: <http://www.w3.org/ns/lemon/ontolex#>
          PREFIX celex: <http://rdf.ivdnt.org/lexica/celex/>
          PREFIX decomp: <http://www.w3.org/ns/lemon/decomp#>
          PREFIX gold: <http://purl.org/linguistics/gold#>
          PREFIX UD: <http://universaldependencies.org/u/>
          PREFIX UDvocab: <http://rdf.ivdnt.org/vocabs/UniversalDependencies2#>
          PREFIX UDgender: <http://universaldependencies.org/u/feat/Gender.html#>
          PREFIX UDnumber: <http://universaldependencies.org/u/feat/Number.html#>          
          PREFIX diamant: <http://rdf.ivdnt.org/schema/diamant#>
        
          
          SELECT DISTINCT 
          ${celexMode} (?celexLemmaId AS ?celexColorId) ?celexLemma ?celexWordform ?celexPronunciation ?celexNumber ?celexGender 
          ${molexMode} (?molexLemId AS ?molexColorId) ?molexLemma ?molexLemPos ?molexWordform ?molexHyphenation ?molexWordformPos ?molexGender ?molexNumber         
          ${celexMode} FROM NAMED <http://rdf.ivdnt.org/lexica/celex/>
          ${molexMode} FROM NAMED <http://rdf.ivdnt.org/lexica/molex>

          WHERE {
            
            ${celexMode} GRAPH <http://rdf.ivdnt.org/lexica/celex/>
            ${celexMode} {            
            ${celexMode}  ?celexLemmaId ontolex:canonicalForm [ontolex:writtenRep ?celexLemma] .
            ${celexMode}  ?celexLemmaId ontolex:lexicalForm ?celexWordformId .
            ${celexMode}  ?celexWordformId ontolex:writtenRep ?celexWordform .            
            ${celexMode}  ${celexSubparts["Lemma"]}
            ${celexMode}  ${celexSubparts["Wordform"]}
          
            ${celexMode}  ${celexOPTIONAL["Number"]} {
            ${celexMode}      ?celexWordformId UDvocab:Number ?dcn . 
            ${celexMode}      ${celexSubparts["Number"]}                
            ${celexMode}      bind( REPLACE(STR(?dcn), "_Number$", "") AS ?celexNumber ) .
            ${celexMode}  }   
            ${celexMode}  OPTIONAL { 
            ${celexMode}      ?celexLemmaId ontolex:lexicalForm ?celexWordformId . 
            ${celexMode}       ?celexWordformId  ontolex:phoneticRep ?celexPronunciation . 
            ${celexMode}  }

            ${celexMode}  ${celexOPTIONAL["Gender"]} {
            ${celexMode}      ?celexLemmaId UDvocab:Gender ?g . 
            ${celexMode}      bind( REPLACE(STR(?g), "_Gender$", "") AS ?celexGender ) .
            ${celexMode} 
            ${celexMode}        bind( STR(
            ${celexMode}          if(?g = UDvocab:Fem_Gender,
            ${celexMode}             "Com",
            ${celexMode}            if(?g = UDvocab:Masc_Gender, 
            ${celexMode}              "Com", 
            ${celexMode}              if(?g = UDvocab:Com_Gender, 
            ${celexMode}                "Com", 
            ${celexMode}                if(?g = UDvocab:Neut_Gender, 
            ${celexMode}                  "Neut", 
            ${celexMode}                  "undef" 
            ${celexMode}                ) 
            ${celexMode}              )
            ${celexMode}             )
            ${celexMode}           ))
            ${celexMode}           AS ?commongender_celex
            ${celexMode}         )
            ${celexMode}        ${celexSubparts["Gender"]}
            ${celexMode}   }              

            ${celexMode}  bind (coalesce(STR(?commongender_celex), "undef") AS ?celexmolexgender) . # join
            ${celexMode}  bind (STR(?celexLemma) AS ?celexmolexlem) . # join
            ${celexMode}  bind (STR(?celexWordform) AS ?celexmolexwf) . # join
            ${celexMode} }
            


            ${molexMode} GRAPH <http://rdf.ivdnt.org/lexica/molex>
            ${molexMode} {

            ${molexMode}  ?molexLemId ontolex:canonicalForm ?molexLemCFId .
            ${molexMode}  ?molexLemId ontolex:lexicalForm ?molexWordformId .
            ${molexMode}  ?molexWordformId ontolex:writtenRep ?molexWordform .
            ${molexMode}  ?molexLemCFId ontolex:writtenRep ?molexLemma . 
            ${molexMode}  ${molexSubparts["Lemma"]}

            ${molexMode}  ${molexOPTIONAL["Wordform"]} {            
            ${molexMode}    ${molexSubparts["Wordform"]}              
            ${molexMode}    ?molexWordformId diamant:hyphenation ?molexHyphenation .
            ${molexMode}  }

            ${molexMode}  OPTIONAL {
            ${molexMode}    ?molexLemId UD:VerbForm ?verbform .
            ${molexMode}  }
            ${molexMode}  ?molexLemId UD:pos ?molexLemPos .
            ${molexMode}  ${molexSubparts["LemPos"]}

            ${molexMode}  ?molexWordformId UD:pos ?molexWordformPos .
            ${molexMode}  ${molexSubparts["WordformPos"]}

            ${molexMode}  ${molexOPTIONAL["Number"]} {
            ${molexMode}    ?molexWordformId UD:Number ?mxNumber .
            ${molexMode}    ${molexSubparts["Number"]}
            ${molexMode}    bind( STR(
            ${molexMode}      if(?mxNumber = UDnumber:Plur,
            ${molexMode}        UDvocab:Plur, 
            ${molexMode}        if(?mxNumber = UDnumber:Sing,
            ${molexMode}          UDvocab:Sing, 
            ${molexMode}          ?mxNumber
            ${molexMode}          )
            ${molexMode}      ))
            ${molexMode}       AS ?molexNumber  
            ${molexMode}     ) 
            ${molexMode}  }

            ${molexMode}  ${molexOPTIONAL["Gender"]} {
            ${molexMode}    ?molexLemId UD:Gender ?mxGender .
            ${molexMode}    bind( STR(
            ${molexMode}      if(?mxGender = UDgender:Fem,   # BEWARE: UDgender -> UDvocab
            ${molexMode}      UDvocab:Fem,
            ${molexMode}        if(?mxGender = UDgender:Masc, 
            ${molexMode}          UDvocab:Masc, 
            ${molexMode}          if(?mxGender = UDgender:Neut, 
            ${molexMode}            UDvocab:Neut, 
            ${molexMode}            ?mxGender
            ${molexMode}          )
            ${molexMode}        )
            ${molexMode}      ))
            ${molexMode}      AS ?molexGender
            ${molexMode}    ) 
            ${molexMode}    bind( STR(
            ${molexMode}      if(?mxGender = UDgender:Fem,     # BEWARE: UDgender -> UDvocab
            ${molexMode}      "Com",
            ${molexMode}        if(?mxGender = UDgender:Masc, 
            ${molexMode}          "Com", 
            ${molexMode}          if(?mxGender = UDgender:Neut, 
            ${molexMode}             "Neut", 
            ${molexMode}            "undef"
            ${molexMode}          )
            ${molexMode}        )
            ${molexMode}       ))
            ${molexMode}      AS ?commongender_molex
            ${molexMode}    )
            ${molexMode}   ${molexSubparts["Gender"]}
            ${molexMode}  }            

            ${molexMode}  bind (coalesce(STR(?commongender_molex), "undef") AS ?celexmolexgender) . # join
            ${molexMode}  bind (STR(?molexLemma) AS ?celexmolexlem) . # join
            ${molexMode}  bind (STR(?molexWordform) AS ?celexmolexwf) . # join
            ${molexMode} }
              
            }
            LIMIT ${paradigmLimit}                
      `;
};


  export default complexQueryBuilder;


// WEBPACK FOOTER //
// ./src/js/complexQueryBuilder.js